import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-mist px-5 py-16 sm:py-20" data-id="element-107" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-108" data-mp="1o5q24hrrqa0i">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-cta-dark" data-id="element-109" data-mp="223ofbjucs0ef">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-110" data-mp="1x5mwn00ua33h" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-ink sm:text-2xl" data-id="element-111" data-mp="19dzdj49tjwbr">
          Save 300 Hours Or Pay Nothing
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-ink/60" data-id="element-112" data-mp="14dtg17gvbflr">
          30-day &ldquo;keep it all&rdquo; guarantee. Try the system risk-free.
          If it doesn&apos;t save you at least 3 hours of prep in your first week
          or make your classroom easier, we&apos;ll refund you every cent.
        </p>
        <p className="mx-auto mt-5 max-w-md rounded-2xl bg-white px-6 py-5 text-sm leading-relaxed text-ink/70" data-id="element-113" data-mp="lpodu4fv02p2">
          <span className="font-bold text-ink" data-id="element-114" data-mp="oygncjtz1mcx">The best part:</span> even if you
          get a refund, you can keep the materials. We only want your money if
          we make your life better.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-cta-dark underline underline-offset-4 transition-colors hover:text-ink" data-id="element-115" data-mp="yqmcllsu9pof">
          Full refund policy
        </a>
      </div>
    </section>;
}